import React from "react";

interface DevelopersPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const DevelopersPagination: React.FC<DevelopersPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handlePrevious = () => {
    onPageChange(Math.max(currentPage - 1, 1));
  };

  const handleNext = () => {
    onPageChange(Math.min(currentPage + 1, totalPages));
  };

  const renderPageNumbers = () => {
    const pageNumbers: (number | string)[] = [];

    pageNumbers.push(1);

    let start = Math.max(2, currentPage - 2);
    let end = Math.min(totalPages - 1, currentPage + 2);

    if (start > 2) {
      pageNumbers.push("...");
    }

    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }

    if (end < totalPages - 1) {
      pageNumbers.push("...");
    }

    if (totalPages > 1) {
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((num, idx) =>
      num === "..." ? (
        <span key={`ellipsis-${idx}`} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={num}
          onClick={() => onPageChange(num as number)}
          className={`md:mx-1 px-2 md:px-3 py-1 rounded-2 ${
            currentPage === num ? "bg-primary text-white" : "bg-white"
          }`}
        >
          {num}
        </button>
      )
    );
  };

  if (totalPages < 1) return null;

  return (
    <div className="mt-4 flex justify-between items-center border p-3 rounded-2">
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className={`px-3 py-1 rounded-2 fw-bold ${
          currentPage !== 1 ? "bg-gray-200" : "current"
        }`}
      >
        Previous
      </button>
      <div className="flex items-center">{renderPageNumbers()}</div>
      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className={`px-3 py-1 rounded-2 fw-bold ${
          currentPage !== totalPages ? "bg-gray-200" : "current"
        }`}
      >
        Next
      </button>
    </div>
  );
};

export default DevelopersPagination;
